
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Terms() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow pt-32 pb-24">
        <div className="container-custom max-w-4xl">
          <h1 className="text-3xl md:text-4xl font-serif mb-8 text-center">Terms of Service</h1>
          <p className="text-right italic mb-8 text-softgray">Last Updated: January 2025</p>
          
          <h2 className="text-xl font-serif mb-3 mt-8">WELCOME TO OUR DIGITAL CLOISTER</h2>
          <p className="mb-4">As you cross the threshold of The Monastery Method, offered by Immaculate Industries Inc. ("we," "our," "us"), we invite you to read these Terms of Service ("Terms"), which govern your use of our website, application process, and services.</p>
          <p className="mb-8">Like the Rule of St. Benedict that has guided monastics for centuries, these Terms provide structure and guidance for our relationship.</p>
          
          <h2 className="text-xl font-serif mb-3 mt-8">ACCEPTING THE RULE</h2>
          <p className="mb-8">By accessing our website or submitting an application, you agree to abide by these Terms. If you do not agree, like a visitor who finds a monastery's rule too demanding, we respectfully ask you to refrain from using our services.</p>
          
          <h2 className="text-xl font-serif mb-3 mt-8">THE PATH OF APPLICATION</h2>
          <p className="mb-4">The application process for The Monastery Method requires:</p>
          <ul className="list-disc pl-8 mb-4">
            <li className="mb-2">Submission of requested information</li>
            <li className="mb-2">Participation in selection conversations if invited</li>
            <li className="mb-2">Adherence to our confidentiality expectations</li>
            <li className="mb-2">Understanding that not all applicants will be selected</li>
          </ul>
          <p className="mb-8">We reserve the right to accept or decline applications at our discretion, guided by our discernment of mutual fit and benefit.</p>
          
          <h2 className="text-xl font-serif mb-3 mt-8">THE SACRED EXCHANGE</h2>
          <p className="mb-4">For those selected to participate in The Monastery Method:</p>
          <ul className="list-disc pl-8 mb-8">
            <li className="mb-2">Payment terms will be clearly communicated</li>
            <li className="mb-2">Investments are non-refundable unless otherwise specified</li>
            <li className="mb-2">Pricing is subject to change for future cohorts</li>
            <li className="mb-2">Payment processing is handled through secure third-party providers</li>
            <li className="mb-2">Currency is in Canadian Dollars unless otherwise specified</li>
          </ul>
          
          <h2 className="text-xl font-serif mb-3 mt-8">THE COVENANT OF CONFIDENTIALITY</h2>
          <p className="mb-4">As monastics have long held secrets in confidence:</p>
          <ul className="list-disc pl-8 mb-8">
            <li className="mb-2">Materials provided are for your personal use only</li>
            <li className="mb-2">Sharing of proprietary content is prohibited without consent</li>
            <li className="mb-2">Respect for the privacy of fellow participants is required</li>
            <li className="mb-2">We maintain confidentiality of your personal information as outlined in our Privacy Policy</li>
          </ul>
          
          <h2 className="text-xl font-serif mb-3 mt-8">INTELLECTUAL PROPERTY: OUR SACRED TEXTS</h2>
          <p className="mb-4">Like manuscripts preserved by scribes:</p>
          <ul className="list-disc pl-8 mb-8">
            <li className="mb-2">All content, materials, and methodologies are our intellectual property</li>
            <li className="mb-2">You may use materials for personal growth only</li>
            <li className="mb-2">Attribution is required for any permitted sharing</li>
            <li className="mb-2">Unauthorized reproduction or distribution is prohibited</li>
          </ul>
          
          <h2 className="text-xl font-serif mb-3 mt-8">THE VIRTUE OF PROPER CONDUCT</h2>
          <p className="mb-4">We ask participants to:</p>
          <ul className="list-disc pl-8 mb-4">
            <li className="mb-2">Engage respectfully with all community members</li>
            <li className="mb-2">Refrain from disruptive or harmful behavior</li>
            <li className="mb-2">Honor the confidentiality of others</li>
            <li className="mb-2">Recognize that transformation requires personal commitment</li>
          </ul>
          <p className="mb-8">We reserve the right to remove participants who violate these principles, without refund.</p>
          
          <h2 className="text-xl font-serif mb-3 mt-8">DIGITAL COMMUNICATIONS: MODERN SCROLLS</h2>
          <p className="mb-4">Regarding email and other communications:</p>
          <ul className="list-disc pl-8 mb-8">
            <li className="mb-2">We will send you information relevant to your journey</li>
            <li className="mb-2">You may opt out of non-essential communications</li>
            <li className="mb-2">Important program information will always be shared</li>
            <li className="mb-2">We are not responsible for communications not received due to technical issues</li>
          </ul>
          
          <h2 className="text-xl font-serif mb-3 mt-8">DISCLAIMER OF WARRANTIES: HUMAN IMPERFECTION</h2>
          <p className="mb-4">Like monks who acknowledged their humanity:</p>
          <ul className="list-disc pl-8 mb-8">
            <li className="mb-2">We provide services "as is" without warranties</li>
            <li className="mb-2">We do not guarantee specific outcomes</li>
            <li className="mb-2">Transformation depends on individual engagement</li>
            <li className="mb-2">We make no representations about suitability for particular purposes</li>
          </ul>
          
          <h2 className="text-xl font-serif mb-3 mt-8">LIMITATION OF LIABILITY: THE BOUNDS OF RESPONSIBILITY</h2>
          <p className="mb-4">Our liability is limited to:</p>
          <ul className="list-disc pl-8 mb-8">
            <li className="mb-2">The amount paid for our services</li>
            <li className="mb-2">Direct damages only</li>
            <li className="mb-2">Exclusion of indirect, incidental, or consequential damages</li>
            <li className="mb-2">Compliance with applicable law</li>
          </ul>
          
          <h2 className="text-xl font-serif mb-3 mt-8">INDEMNIFICATION: MUTUAL PROTECTION</h2>
          <p className="mb-4">You agree to protect us, as we protect you, from:</p>
          <ul className="list-disc pl-8 mb-8">
            <li className="mb-2">Claims arising from your use of our services</li>
            <li className="mb-2">Violations of these Terms</li>
            <li className="mb-2">Actions that harm others</li>
          </ul>
          
          <h2 className="text-xl font-serif mb-3 mt-8">TERMINATION: WHEN PATHS DIVERGE</h2>
          <p className="mb-4">Like a monk who may leave the monastery:</p>
          <ul className="list-disc pl-8 mb-8">
            <li className="mb-2">You may cease participation at any time (refunds subject to our policy)</li>
            <li className="mb-2">We may terminate your access for violations of these Terms</li>
            <li className="mb-2">Some provisions survive termination (intellectual property, confidentiality)</li>
          </ul>
          
          <h2 className="text-xl font-serif mb-3 mt-8">GOVERNING LAW: THE RULE OF THE LAND</h2>
          <p className="mb-4">These Terms are governed by:</p>
          <ul className="list-disc pl-8 mb-8">
            <li className="mb-2">The laws of Ontario, Canada</li>
            <li className="mb-2">Without regard to conflict of law principles</li>
            <li className="mb-2">The courts of Ontario for dispute resolution</li>
          </ul>
          
          <h2 className="text-xl font-serif mb-3 mt-8">FORCE MAJEURE: ACTS BEYOND CONTROL</h2>
          <p className="mb-4">Like monastics who submitted to forces of nature:</p>
          <ul className="list-disc pl-8 mb-8">
            <li className="mb-2">We are not liable for failures due to circumstances beyond reasonable control</li>
            <li className="mb-2">Including natural disasters, pandemics, war, civil unrest, or technological failures</li>
          </ul>
          
          <h2 className="text-xl font-serif mb-3 mt-8">SEVERABILITY: THE STRENGTH OF THE WHOLE</h2>
          <p className="mb-4">If any provision is found unenforceable:</p>
          <ul className="list-disc pl-8 mb-8">
            <li className="mb-2">The remaining provisions continue in effect</li>
            <li className="mb-2">The unenforceable provision will be modified to reflect our intention</li>
          </ul>
          
          <h2 className="text-xl font-serif mb-3 mt-8">ENTIRE AGREEMENT & AMENDMENTS</h2>
          <p className="mb-4">These Terms constitute:</p>
          <ul className="list-disc pl-8 mb-8">
            <li className="mb-2">The complete understanding between us</li>
            <li className="mb-2">Superseding prior agreements</li>
            <li className="mb-2">Subject to revision with notice</li>
          </ul>
          
          <h2 className="text-xl font-serif mb-3 mt-8">CONTACT US: A CALL TO THE PORTER</h2>
          <p className="mb-4">For questions about these Terms:</p>
          <p className="mb-2">Immaculate Industries Inc.</p>
          <p className="mb-8">[knock@themonasterymethod.com]</p>
          
          <p className="italic text-center mt-12 mb-8">"Let all guests who arrive be received like Christ." – Rule of St. Benedict</p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
